export type ProgrammingTabBlockReason = "started" | "unscheduled" | null;

export const PROGRAMMING_TAB_TOOLTIP_KEYS: Record<
  Exclude<ProgrammingTabBlockReason, null>,
  string
> = {
  started: "programming-edit.tabs.programming-started-tooltip",
  unscheduled: "programming-edit.tabs.programming-disabled-tooltip",
};

interface ProgrammingLockInputs {
  hasAppliedStructure: boolean;
  isStarted: boolean;
  canEditStartedLinks: boolean;
  hasUnscheduledSessions: boolean;
  hasProgrammingAbility: boolean;
  isEligibleForProgramming: boolean;
}

/** Shared decisions for the sessions editor and calendar event actions. */
export const deriveProgrammingLockState = ({
  hasAppliedStructure,
  isStarted,
  canEditStartedLinks,
  hasUnscheduledSessions,
  hasProgrammingAbility,
  isEligibleForProgramming,
}: ProgrammingLockInputs) => {
  const isBlockedByStartedLink = isStarted && !canEditStartedLinks;
  const programmingTabBlockReason: ProgrammingTabBlockReason =
    isBlockedByStartedLink && !hasAppliedStructure
      ? "started"
      : hasUnscheduledSessions
        ? "unscheduled"
        : null;

  return {
    hasAppliedStructure,
    isStarted,
    canEditProgramming: hasProgrammingAbility && isEligibleForProgramming,
    programmingTabBlockReason,
    isProgrammingReadOnly: isBlockedByStartedLink && hasAppliedStructure,
    isAssignationLocked: hasAppliedStructure,
  };
};

export type ProgrammingLockState = ReturnType<typeof deriveProgrammingLockState>;
